import React from 'react';
import PropTypes from 'prop-types';
import { TERM } from '../../constants/labels';

class TermSelect extends React.Component {
	render() {
		const { value, list, updateValue, passedProps } = this.props;

		const createTermOptions = (termLength, i) => {
			return (
				<option key={`${i} - ${termLength}`} value={termLength}>
					{termLength} Months
				</option>
			);
		};

		return (
			<div className="form-group">
				{/* eslint-disable-next-line jsx-a11y/label-has-for */}
				<label
					id="pac-selectTerm-Label"
					htmlFor="pc-selectTerm"
					className="control-label"
				>
					{TERM}
					<select
						{...passedProps}
						value={value}
						onChange={e => {
							const val = e.target.value;
							updateValue(parseInt(val, 10));
						}}
					>
						{list.map(createTermOptions)}
					</select>
				</label>
			</div>
		);
	}
}

TermSelect.propTypes = {
	value: PropTypes.number.isRequired,
	list: PropTypes.arrayOf(PropTypes.number).isRequired,
	updateValue: PropTypes.func.isRequired,
	passedProps: PropTypes.shape({})
};

TermSelect.defaultProps = {
	passedProps: {}
};

export default TermSelect;



// WEBPACK FOOTER //
// ./src/components/inputs/TermSelect.jsx